var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-bar py-2 text-bg-primary"},[_c('div',{staticClass:"container"},[(typeof _vm.HeaderTop == 'object')?_c('cmsBlockSimple',{staticClass:"header-top-text",attrs:{"identifier":_vm.HeaderTop.identifier}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }